export default Object.freeze({
  UntilChildrenFinish: 'until-children-finish',
  UntilChildrenCompleteSpecificAction: 'until-children-complete-specific-action',
});
